<template>
<div>
  <TableModule />
</div>

</template>
<script>
import TableModule from "./components/tableModule";
export default {
  components: {
    TableModule,
  },
  methods: {},
  created() {},
};
</script>
<style></style>
